<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.station')"
    resource="stations"
    :batch-actions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/stations.js';
import _ from 'lodash';

@Component
export default class Stations extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      { key: 'country_cont', label: '国家' },
      { key: 'name_cont', label: '名称' },
      'eurostar_uic_cont',
      'eurostar_active_eq',
      'popular_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'eurostar_uic',
      'position',
      'eurostar_active',
      'popular',
      'country',
      'name',
      'name_zh_cn',
      'short_code',
      'prompt',
      type === 'show' && 'std_ticket_tips',
      type === 'show' && 'sp_ticket_tips',
      type === 'show' && 'bp_ticket_tips',
      type === 'show' && {
        prop: 'fake_leg.short_name',
        label: '假车程短称'
      },
      type === 'show' && {
        prop: 'fake_leg.tips',
        label: '假车程提示语'
      },
      type === 'show' && {
        prop: 'fake_leg.notice_title',
        label: '假车程注意事项标题'
      },
      type === 'show' && {
        prop: 'fake_leg.notice_content',
        label: '假车程注意事项内容'
      },
      type === 'show' && 'non_flexible_desc',
      type === 'show' && 'semi_flexible_desc',
      type === 'show' && 'fully_flexible_desc',
      type === 'show' && 'standard_services',
      type === 'show' && 'standard_premier_services',
      type === 'show' && 'business_premier_services',
      type === 'show' && 'nov_standard_services',
      type === 'show' && 'nov_standard_premier_services',
      type === 'show' && 'nov_business_premier_services',
      type === 'show' && 'local_sceneries',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      {
        prop: 'eurostar_uic',
        label: 'UIC',
        renderCell: {
          component: 'input',
          props: {
            disabled: true
          }
        }
      },
      'country',
      {
        prop: 'name',
        label: '名称',
        renderCell: {
          component: 'input',
          props: {
            disabled: true
          }
        }
      },
      'name_zh_cn',
      {
        prop: 'short_code',
        label: 'Short Code',
        renderCell: {
          component: 'input',
          props: {
            disabled: true
          }
        }
      },
      'popular',
      'prompt',
      {
        prop: 'std_ticket_tips',
        label: '标准舱车票提示语',
        renderCell: {
          component: 'input',
          hint: '标准舱车票提示语, 展示在车票页面'
        }
      },
      {
        prop: 'sp_ticket_tips',
        label: '标准贵宾舱车票提示语',
        renderCell: {
          component: 'input',
          hint: '标准贵宾舱车票提示语, 展示在车票页面'
        }
      },
      {
        prop: 'bp_ticket_tips',
        label: '商务舱车票提示语',
        renderCell: {
          component: 'input',
          hint: '商务舱车票提示语, 展示在车票页面'
        }
      },
      {
        prop: 'fake_leg.short_name',
        label: '假车程短称',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'fake_leg.tips',
        label: '假车程提示语',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'fake_leg.notice_title',
        label: '假车程注意事项标题',
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'fake_leg.notice_content',
        label: '假车程注意事项内容',
        renderCell: {
          component: 'input'
        }
      },
      'non_flexible_desc',
      'semi_flexible_desc',
      'fully_flexible_desc',
      {
        key: 'standard_services',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750*height`,
        }
      },
      {
        key: 'standard_premier_services',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750*height`,
        }
      },
      {
        key: 'business_premier_services',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750*height`,
        }
      },
      {
        key: 'nov_standard_services',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750*height`,
          props: {
            cropper: {
              width: 686,
              height: 336
            }
          }
        }
      },
      {
        key: 'nov_standard_premier_services',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750*height`,
          props: {
            cropper: {
              width: 686,
              height: 336
            }
          }
        }
      },
      {
        key: 'nov_business_premier_services',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750*height`,
          props: {
            cropper: {
              width: 600,
              height: 509
            }
          }
        }
      },
      {
        prop: 'local_scenery_ids',
        label: this.$t('station.localSceneries'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            filterable: true,
            multiple: true,
            options: _.map(data.local_sceneries, ({ id, name }) => ({ value: id, label: name })),
            'x-remote': {
              strategy: 'search',
              remoteMethod: async (name_cont) => {
                const { data } = await this.$request.get('local_sceneries', { params: { name_cont } })
                return _.map(data, ({ id, name }) => ({ value: id, label: name }))
              }
            }
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'stations.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'stations.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

    /**
  * @param {Object} scope -表格 scope 数据
  * @param {Object} scope.selection - 表格已选择行数据
  * @param {Object} sourcePageScope
  * @param {Function} sourcePageScope.remove - sourcePage删除方法
  * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
  */
  batchActions({ selection }, { resource }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i>{this.$t('export')}</el-button>
    ];
  }
}

export const route = [
  {
    path: '/stations',
    name: 'stations.index',
    component: Stations,
    props: {
      type: 'index',
    }
  },
  {
    path: '/stations/new',
    name: 'stations.new',
    component: Stations,
    props: {
      type: 'new',
    }
  },
  {
    path: '/stations/:id',
    name: 'stations.show',
    component: Stations,
    props: {
      type: 'show',
    }
  },
  {
    path: '/stations/:id/edit',
    name: 'stations.edit',
    component: Stations,
    props: {
      type: 'edit'
    }
  }
]
</script>
